import styled, { css } from 'styled-components'

const FitButtonContainer = styled.button`
  ${props =>
    props.styleTu &&
    css`
      font-family: ${props.theme.font.family.base};
      font-weight: 400;
      font-size: 16px;
      border: none;
      border-radius: 25px;
      color: ${props.theme.color.monochrome.dark};
      background-color: ${props.theme.color.monochrome.lighter};
      margin-bottom: 10px;
      padding: 10px 15px;
    `}
  ${props =>
    !props.styleTu &&
    css`
      color: ${props.theme.color.palette['brand-1']};
      font-weight: ${props.theme.font.weight.bold};
      text-decoration: underline;
      cursor: pointer;

      &:hover,
      &:active {
        color: ${props.theme.color.palette['brand-1-dark']};
      }
    `}
`
const FitButtonContent = styled.span`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  > svg {
    margin-right: 8px;
    align-self: flex-start;
  }
`
const FitButtonText = styled.span`
  text-align: left;
  line-height: 1.2;
`
export { FitButtonContainer, FitButtonContent, FitButtonText }
